/**
 * 카카오 로그인 콜백 — Redirect URI(/oauth/kakao)
 * ?code 받아 → kakaoCustomToken 함수 → Firebase 커스텀 토큰 로그인
 */
import React, { useEffect, useState, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import styled from 'styled-components';
import { signInWithCustomToken } from 'firebase/auth';
import { auth } from '../../firebase/config';
import { APP_CONFIG } from '../../config/appConfig';
import { getUserProfileByUid, landingPathFor } from '../../services/userProfileService';
import BrandLoader from '../../components/common/BrandLoader';

const KakaoCallbackPage = () => {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const [error, setError] = useState('');
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;

    const code = params.get('code');
    if (!code) {
      setError('카카오 인증 코드를 받지 못했어요.');
      return;
    }

    (async () => {
      try {
        const res = await fetch(APP_CONFIG.kakaoCustomTokenUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            code,
            redirectUri: `${window.location.origin}/oauth/kakao`,
          }),
        });
        const data = await res.json();
        if (!res.ok || !data.customToken) {
          throw new Error(data.error || '토큰 발급 실패');
        }
        const cred = await signInWithCustomToken(auth, data.customToken);
        // 가입유형에 맞는 첫 화면으로 직행 (홈 깜빡임 방지)
        const profile = await getUserProfileByUid(cred.user.uid);
        navigate(landingPathFor(profile), { replace: true });
      } catch (e) {
        console.error('카카오 로그인 실패:', e);
        setError('카카오 로그인에 실패했어요. 다시 시도해 주세요.');
      }
    })();
  }, [params, navigate]);

  if (error) {
    return (
      <Center>
        <ErrText>{error}</ErrText>
        <RetryBtn type="button" onClick={() => navigate('/app/login', { replace: true })}>
          로그인으로 돌아가기
        </RetryBtn>
      </Center>
    );
  }

  return <BrandLoader fullscreen />;
};

export default KakaoCallbackPage;

const Center = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 0 30px;
  background: #fff;
`;

const ErrText = styled.p`
  font-size: 14.5px;
  text-align: center;
  color: ${({ theme }) => theme.colors.text.secondary};
`;

const RetryBtn = styled.button`
  padding: 13px 28px;
  border-radius: 22px;
  background: ${({ theme }) => theme.colors.primaryGradient};
  color: #fff;
  font-size: 14px;
  font-weight: 700;
`;
